import {isFeatureKey as e, isRangeKey as t, RANGE_NUMBER_FEATURES as n} from './helpers.js'
const i = {
	widthPx: 1920,
	heightPx: 1080,
	writingMode: 'horizontal-tb',
	emPx: 16,
	lhPx: 16,
	exPx: 8,
	chPx: 8,
	capPx: 11,
	icPx: 16
}
export const convertToUnit = (e, t) => {
	if ('number' === e.type) return {type: 'number', value: e.value}
	if ('dimension' === e.type) {
		let n
		switch (e.unit) {
			case 's':
			case 'ms':
				n = 'time'
				break
			case 'hz':
			case 'khz':
				n = 'frequency'
				break
			case 'dpi':
			case 'dpcm':
			case 'dppx':
			case 'x':
				n = 'resolution'
				break
			default:
				n = 'length'
		}
		if ('px' === e.unit) return {type: 'dimension', subtype: 'length', px: e.value}
		if ('time' === n)
			return {
				type: 'dimension',
				subtype: 'time',
				ms: 's' === e.unit ? Math.round(1e3 * e.value) : e.value
			}
		if ('frequency' === n)
			return {
				type: 'dimension',
				subtype: 'frequency',
				hz: 'khz' === e.unit ? Math.round(1e3 * e.value) : e.value
			}
		if ('resolution' === n) {
			let t = e.value
			return (
				'dpi' === e.unit
					? (t = Number.parseFloat((0.0104166667 * e.value).toFixed(3)))
					: 'dpcm' === e.unit && (t = Number.parseFloat((0.0264583333 * e.value).toFixed(3))),
				{type: 'dimension', subtype: 'resolution', dppx: t}
			)
		}
		if (e.unit in t) {
			const n = t[e.unit]
			return {type: 'dimension', subtype: 'length', px: Number.parseFloat((e.value * n).toFixed(3))}
		}
		return {type: 'ident', value: '{never}'}
	}
	return 'ident' === e.type
		? 'infinite' === e.value
			? {type: 'infinite'}
			: {type: 'ident', value: e.value}
		: {type: 'ratio', numerator: e.numerator, denominator: e.denominator}
}
export const compileStaticUnitConversions = e => {
	let t = {}
	'number' == typeof e.emPx &&
		(t = {
			exPx: Math.round(0.5 * e.emPx),
			chPx: Math.round(0.5 * e.emPx),
			capPx: Math.round(0.7 * e.emPx),
			icPx: Math.round(e.emPx)
		})
	const n = {...i, ...t, ...e},
		{
			widthPx: r,
			heightPx: o,
			writingMode: a,
			emPx: u,
			lhPx: p,
			exPx: l,
			chPx: m,
			capPx: s,
			icPx: f
		} = n,
		v = r / 100,
		c = o / 100
	return {
		em: u,
		rem: u,
		lh: p,
		rlh: p,
		ex: l,
		ch: m,
		cap: s,
		ic: f,
		vw: v,
		vh: c,
		vmin: Math.min(c, v),
		vmax: Math.max(c, v),
		vi: 'horizontal-tb' === a ? v : c,
		vb: 'horizontal-tb' === a ? c : v,
		cm: 37.79527559,
		mm: 0.03779527559,
		in: 96,
		q: 0.009448818898,
		pc: 16,
		pt: 16
	}
}
const r = {'<': '>', '<=': '>=', '>': '<', '>=': '<='}
export const simplifyMediaFeature = (n, i) => {
	if ('range' === n.context) {
		if (t(n.feature)) {
			const {range: e, feature: t} = n
			return void 0 !== e.leftToken && void 0 !== e.rightToken
				? '<' === e.leftOp || '<=' === e.leftOp
					? {
							type: 'double',
							name: t,
							minOp: e.leftOp,
							min: convertToUnit(e.leftToken, i),
							maxOp: e.rightOp,
							max: convertToUnit(e.rightToken, i)
					  }
					: {
							type: 'double',
							name: t,
							minOp: '>' === e.rightOp ? '<' : '<=',
							min: convertToUnit(e.rightToken, i),
							maxOp: e.leftOp ? '<' : '<=',
							max: convertToUnit(e.leftToken, i)
					  }
				: void 0 === e.rightToken
				? '=' === e.leftOp
					? {type: 'equals', name: t, value: convertToUnit(e.leftToken, i)}
					: {type: 'single', name: t, op: r[e.leftOp], value: convertToUnit(e.leftToken, i)}
				: '=' === e.rightOp
				? {type: 'equals', name: t, value: convertToUnit(e.rightToken, i)}
				: {type: 'single', name: t, op: e.rightOp, value: convertToUnit(e.rightToken, i)}
		}
	} else if ('value' === n.context) {
		if ('orientation' === n.feature) {
			if (void 0 === n.prefix && 'ident' === n.value.type) {
				if ('portrait' === n.value.value)
					return {
						type: 'single',
						name: 'aspect-ratio',
						op: '<=',
						value: {type: 'ratio', numerator: 1, denominator: 1}
					}
				if ('landscape' === n.value.value)
					return {
						type: 'single',
						name: 'aspect-ratio',
						op: '>=',
						value: {type: 'ratio', numerator: 1, denominator: 1}
					}
			}
		} else if (e(n.feature)) {
			if (void 0 === n.prefix)
				return {type: 'equals', name: n.feature, value: convertToUnit(n.value, i)}
			if (t(n.feature))
				return 'min' === n.prefix
					? {type: 'single', name: n.feature, op: '>=', value: convertToUnit(n.value, i)}
					: {type: 'single', name: n.feature, op: '<=', value: convertToUnit(n.value, i)}
		}
	} else {
		if ('orientation' === n.feature)
			return {
				type: 'double',
				name: 'aspect-ratio',
				min: {type: 'ratio', numerator: 0, denominator: 1},
				minOp: '<',
				maxOp: '<',
				max: {type: 'ratio', numerator: Number.POSITIVE_INFINITY, denominator: 1}
			}
		if (e(n.feature)) return {type: 'boolean', name: n.feature}
	}
	return {type: 'invalid', name: n.feature}
}
export const getRatio = e =>
	'number' === e.type && e.value > 0
		? [e.value, 1]
		: 'ratio' === e.type
		? [e.numerator, e.denominator]
		: null
export const getValue = (e, t) => {
	const i = n[t]
	if ('infinite' === e.type) {
		if ('resolution' === t) return Number.POSITIVE_INFINITY
	} else if ('integer' === i.type) {
		if ('number' === e.type && Number.isInteger(e.value)) return e.value
	} else if ('resolution' === i.type) {
		if ('dimension' === e.type && 'resolution' === e.subtype) return e.dppx
	} else if ('length' === i.type) {
		if ('dimension' === e.type && 'length' === e.subtype) return e.px
		if ('number' === e.type && 0 === e.value) return 0
	}
	return null
}
